<template>
  <div
    v-if="videoUrl"
    data-qa="advantage_video"
    class="advantage-video"
    :class="{ 'advantage-video--mobile': isMobile }"
  >
    <div
      class="advantage-video__glow bg-lpu-branding-color-primary"
      aria-hidden="true"
    />
    <div
      class="advantage-video__star"
      aria-hidden="true"
    />
    <button
      type="button"
      data-qa="advantage_video_play"
      class="advantage-video__card rounded-20"
      @click="handleOpenVideoCard"
    >
      <template v-if="previewUrl">
        <v-img
          class="advantage-video__preview-blur"
          :src="previewUrl"
          aria-hidden="true"
        />
        <v-img
          class="advantage-video__preview"
          :src="previewUrl"
          :alt="tStatic('Видеовизитка')"
          contain
        />
      </template>
      <template v-else>
        <video
          class="advantage-video__preview-blur"
          :src="videoUrl"
          muted
          playsinline
          preload="metadata"
          aria-hidden="true"
        />
        <video
          class="advantage-video__preview"
          :src="videoUrl"
          muted
          playsinline
          preload="metadata"
        />
      </template>

      <VideoCard
        ref="videoCardRef"
        :video-url="videoUrl"
        :video-uuid="videoUuid"
      >
        <template #play-button>
          <span
            class="advantage-video__play-btn branding-btn branding-btn--primary-icon d-inline-flex align-center justify-center rounded-circle"
            aria-hidden="true"
          >
            <span
              class="ui-icon-player-play advantage-video__play-btn-icon"
            />
          </span>
        </template>
      </VideoCard>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import VideoCard from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/VideoCard/VideoCard.vue'

defineProps<{
  videoUrl: string
  videoUuid: string
  previewUrl?: string
}>()

const isMobile = useIsMobile()
const videoCardRef = ref<InstanceType<typeof VideoCard> | null>(null)

function handleOpenVideoCard() {
  videoCardRef.value?.openDialog()
}
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.advantage-video {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 430px;
  height: 508px;
  flex-shrink: 0;

  &--mobile {
    width: 351px;
    height: 432px;
    max-width: 100%;
    margin: 0 auto;
  }

  &__glow {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 320px;
    height: 320px;
    border-radius: $border-radius-round;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  &__star {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 430px;
    height: 508px;
    background-color: $ui-kit-bg-gray-60;
    transform: translate(-50%, -50%);
    pointer-events: none;

    // 4-конечная звезда
    clip-path: polygon(
      50% 0%,
      50.71% 49.29%,
      100% 50%,
      50.71% 50.71%,
      50% 100%,
      49.29% 50.71%,
      0% 50%,
      49.29% 49.29%
    );
  }

  &--mobile &__star {
    width: 351px;
    height: 413px;
  }

  &__card {
    position: relative;
    z-index: 1;
    aspect-ratio: 9 / 16;
    width: 246px;
    height: 438px;
    max-height: 100%;
    padding: 0;
    border: 0;
    overflow: hidden;
    cursor: pointer;
    background-color: var(--lpu-branding-color-background) !important;
    box-shadow:
      0 1px 2px 0 rgba(5, 23, 40, 0.08),
      0 0 2px 0 rgba(21, 40, 92, 0.06),
      0 2px 24px 0 rgba(9, 42, 72, 0.08);

    &:focus {
      outline: none;
    }
  }

  &--mobile &__card {
    width: 243px;
    height: 432px;
  }

  &__preview-blur {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: blur(24px);
    transform: scale(1.15);
    pointer-events: none;
  }

  &__preview {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    pointer-events: none;
  }

  &__play-btn {
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 50%;
    width: 46px;
    height: 46px;
    transform: translate(-50%, -50%);
    pointer-events: none;
  }

  &__play-btn-icon::before {
    font-size: 32px;
    position: relative;
    left: 2px;
  }
}
</style>
